import config from 'config';
import { css, mq, styled } from 'mymoria-ui';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Header } from 'components';
import { Redirect, Route, Switch } from 'react-router-dom';
import { NotFoundPage, Overview } from 'containers';

const {
  app: { head },
} = config;

/* todo: apply Page layout component from the funnel project */
const Content = styled.div(
  mq({
    minHeight: ['93vh', '93vh', '91vh'],
    paddingTop: ['4rem', '4rem', '5rem'],
  }),
);

const FlexBoxWrapper = styled.div(
  ({ theme: { colors } }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${colors.backgroundPrimary};
  `,
);

const App = () => (
  <>
    <Helmet {...head} />
    <FlexBoxWrapper>
      <Header />
      <Content>
        <Switch>
          <Redirect exact from="/" to="/overview" />
          <Route path="/overview" component={Overview} />
          <Route component={NotFoundPage} />
        </Switch>
      </Content>
    </FlexBoxWrapper>
  </>
);

export default App;
